import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import { Workshop } from '../api/types';
import config from '../config';

async function getWorkshop(axios: AxiosInstance, id: number): Promise<Workshop> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v2/workshops/${id}`);
  return data.data;
}

export default function useWorkshopQuery(id: number) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(id),
    queryFn: () => getWorkshop(axios, id),
    enabled: !!id,
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(id: number) {
  return ['workshop', id] as const satisfies QueryKey;
}

useWorkshopQuery.getKey = getKey;
